export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5300.86f6644f.jpg";